export const normalizeTicketType = (t) => {
  let firstCategory, secondCategory;

  let type = t.toUpperCase();

  switch (type) {
    case "STUCK_ORDER":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Pesanan Stuck";
      break;
    case "FAILED_PICKUP":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Paket Belum Dijemput/ Gagal Pick-Up";
      break;
    case "OVERSLA":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Pengiriman Lewat Estimasi (Over SLA)";
      break;
    case "NOT_ACCEPTING_GOODS":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Tidak Merasa Menerima Paket";
      break;
    case "ADDRESS_CHANGED":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Ganti Alamat";
      break;
    case "TRACKING_NOT_UPDATED":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Status Pesanan Tidak Update";
      break;
    case "WEIGHT_OR_PAYMENT_DISCREPANCY":
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Selisih Berat/ Pembayaran";
      break;
    case "COD_DISBURSEMENT":
      firstCategory = "Cash On Delivery (COD)";
      secondCategory = "Pencairan Dana COD";
      break;
    case "COD_DISBURSEMENT_ORDER_STATUS_NOT_DELIVERED":
      firstCategory = "Cash On Delivery (COD)";
      secondCategory = "Status Pesanan Belum Delivered";
      break;
    case "INQUIRY":
      firstCategory = "Pertanyaan";
      secondCategory = "Pertanyaan";
      break;
    case "ERROR_DASHBOARD":
      firstCategory = "Dasbor";
      secondCategory = "Dasbor Error";
      break;
    case "WALLET_DASHBOARD":
      firstCategory = "Dasbor";
      secondCategory = "Saldo Bite Points";
      break;
    case "RETURN_RECIPIENT_NOT_PLACING_ORDER":
      firstCategory = "Retur";
      secondCategory = "Penerima Retur Tidak Merasa Mengirim Barang";
      break;
    case "RETURN_RECIPIENT_NOT_IN_PLACE":
      firstCategory = "Retur";
      secondCategory = "Penerima Retur Tidak Ditempat";
      break;
    case "RETURN_RECIPIENT_CANNOT_CONTACTED":
      firstCategory = "Retur";
      secondCategory = "Penerima Retur Tidak Dapat Dihubungi";
      break;
    case "RETURN_ADDRESS_NOT_FOUND":
      firstCategory = "Retur";
      secondCategory = "Alamat Retur Tidak Ditemukan";
      break;
    case "RETURN_OVERSLA":
      firstCategory = "Retur";
      secondCategory = "Pengiriman Retur Lewat Estimasi (Over SLA)";
      break;
    case "RETURN_RECIPIENT_NOT_RECEIVING_PACKAGE":
      firstCategory = "Retur";
      secondCategory = "Tidak Merasa Menerima Paket Retur";
      break;
    case "CLAIM_PACKAGE_LOST":
      firstCategory = "Klaim Paket Hilang/ Rusak";
      secondCategory = "Klaim Paket Hilang";
      break;
    case "CLAIM_PACKAGE_BROKEN":
      firstCategory = "Klaim Paket Hilang/ Rusak";
      secondCategory = "Klaim Paket Rusak";
      break;
    case "CLAIM_OVERSLA":
      firstCategory = "Klaim Paket Hilang/ Rusak";
      secondCategory = "Klaim Pengiriman Lewat Estimasi (Over SLA)";
      break;
    case "INTEGRATION_API":
      firstCategory = "Integrasi";
      secondCategory = "API";
      break;
    case "INTEGRATION_WOOCOMMERCE":
      firstCategory = "Integrasi";
      secondCategory = "WooCommerce";
      break;
    case "INTEGRATION_SHOPIFY":
      firstCategory = "Integrasi";
      secondCategory = "Shopify";
      break;
    case "API_RATES_NOT_WORKING":
      firstCategory = "Integrasi API";
      secondCategory = "API Rates Tidak Berfungsi";
      break;
    case "API_TRACKING_NOT_WORKING":
      firstCategory = "Integrasi API";
      secondCategory = "API Tracking Tidak Berfungsi";
      break;
    case "API_ORDERS_NOT_WORKING":
      firstCategory = "Integrasi API";
      secondCategory = "API Orders Tidak Berfungsi";
      break;
    case "WEBHOOK_NOT_WORKING":
      firstCategory = "Integrasi API";
      secondCategory = "Webhook Tidak Berfungsi";
      break;
    case "INTEGRATION_GUDANG":
      firstCategory = "Integrasi Gudang.io";
      secondCategory = "Integrasi Gudang.io Bermasalah";
      break;
    case "CANNOT_ACTIVATE_SHOPIFY_PLUGIN":
      firstCategory = "Integrasi Shopify";
      secondCategory = "Tidak Dapat Mengaktifkan Plugin Shopify";
      break;
    case "CANNOT_IMPORT_SHOPIFY_ORDERS_EXPRESS_COURIER":
      firstCategory = "Integrasi Shopify";
      secondCategory = "Tidak Dapat Import Pesanan Kurir Reguler Shopify";
      break;
    case "CANNOT_IMPORT_SHOPIFY_ORDERS_INSTANT_COURIER":
      firstCategory = "Integrasi Shopify";
      secondCategory = "Tidak Dapat Import Pesanan Kurir Instant Shopify";
      break;
    case "WOOCOMMERCE_CHECKOUT_PAGE":
      firstCategory = "Integrasi Woo";
      secondCategory = "Halaman Checkout Woocommerce Bermasalah";
      break;
    case "CANNOT_GENERATE_WOOCOMMERCE_AWB":
      firstCategory = "Integrasi Woo";
      secondCategory = "Tidak Dapat Membuat Resi Woocommerce";
      break;
    case "CANNOT_ACTIVATE_WOOCOMMERCE_PLUGIN":
      firstCategory = "Integrasi Woo";
      secondCategory = "Tidak Dapat Mengaktifkan Plugin Woocommerce";
      break;
    default:
      firstCategory = "Penjemputan/ Pengiriman";
      secondCategory = "Pesanan Stuck";
      break;
  }

  return {
    firstCategory,
    secondCategory,
  };
};

export const statusMapper = (status) => {
  let title, fontClass, bgClass;
  switch (status) {
    case "active":
      title = "Aktif";
      fontClass = "text-info-700";
      bgClass = "bg-info-200";
      break;
    case "processing":
      title = "Diproses";
      fontClass = "text-warning-700";
      bgClass = "bg-warning-300";
      break;
    case "solved":
      title = "Selesai";
      fontClass = "text-success-700";
      bgClass = "bg-success-200";
      break;

    default:
      title = "Selesai";
      fontClass = "text-success-700";
      bgClass = "bg-success-200";
      break;
  }

  return { title, fontClass, bgClass };
};
